var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-layout"},[_c('pace-component'),_c('main',{staticClass:"page-layout__main ml-0"},[_c('AdminHeader'),_c('AdminHeading'),_c('TransitionTemplate',[_c('router-view')],1),_c('AdminFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }